import {
    type BankAccountDisplayDetail,
    type DepositAccount,
    type IncomeSplitConfig,
    type IncomeSplitConfigLegacy,
    IncomeSplitRulesList,
    IncomeSplitRulesListNew,
    type PaycheckRoutingRuleAccountMetadata,
} from '@fruitful/income-split';
import IncomeSplitEndOfRules from '@fruitful/income-split/src/components/IncomeSplitEndOfRules';
import {
    type ImAccount,
    type MoneyMapAccount,
    MoneyMapAccountType,
    type MoneyMapRuleWithAccount,
} from '@fruitful/types';
import { BodyMediumRegular, YStack } from 'smoothie';

import {
    PreviewSection,
    PreviewSectionIconMap,
} from '../../types/PreviewSection';
import { PreviewContainer } from './PreviewContainer';
import PreviewSectionHeader from './PreviewSectionHeader';

interface MoneyMapPreviewIncomeSplitProps {
    incomeMoneyMapAccount?: MoneyMapAccount;
    accounts:
        | PaycheckRoutingRuleAccountMetadata[]
        | BankAccountDisplayDetail[]
        | DepositAccount[];
    externalAccounts: DepositAccount[];
    internalInvestmentAccounts?: ImAccount[];
    moneyMapRulesWithProposedAccounts?: MoneyMapRuleWithAccount[];
    incomeSplit: IncomeSplitConfigLegacy | IncomeSplitConfig;
    moneyMapHasGroups: boolean;
}

export const PreviewIncomeSplit = ({
    incomeMoneyMapAccount,
    accounts,
    externalAccounts,
    internalInvestmentAccounts,
    moneyMapRulesWithProposedAccounts,
    incomeSplit,
    moneyMapHasGroups = false,
}: MoneyMapPreviewIncomeSplitProps) => {
    return (
        <PreviewContainer>
            <YStack gap={8} maxWidth={640}>
                <PreviewSectionHeader
                    icon={PreviewSectionIconMap[PreviewSection.INCOME_SPLIT]}
                    title={PreviewSection.INCOME_SPLIT}
                    rotate={true}
                />
                {incomeMoneyMapAccount?.type ===
                MoneyMapAccountType.INTERNAL_BANKING ? (
                    moneyMapHasGroups ? (
                        <>
                            <IncomeSplitRulesListNew
                                incomeSplit={incomeSplit as IncomeSplitConfig}
                                externalAccounts={externalAccounts}
                                internalInvestmentAccounts={
                                    internalInvestmentAccounts
                                }
                                moneyMapRulesWithProposedAccounts={
                                    moneyMapRulesWithProposedAccounts
                                }
                                bankAccountDetails={accounts}
                            />
                            <IncomeSplitEndOfRules />
                        </>
                    ) : (
                        <IncomeSplitRulesList
                            incomeSplit={incomeSplit as IncomeSplitConfigLegacy}
                            externalAccounts={externalAccounts}
                            moneyMapRulesWithProposedAccounts={
                                moneyMapRulesWithProposedAccounts
                            }
                            bankAccountDetails={accounts}
                        />
                    )
                ) : (
                    <BodyMediumRegular>
                        Only Money Maps with income flowing into Fruitful
                        accounts are eligible for Income Split.
                    </BodyMediumRegular>
                )}
            </YStack>
        </PreviewContainer>
    );
};
